<template>
  <!-- Keyed on the full path so every navigation - including one that only changes params or the
       query on the same page (a different calendar's Matches, Daily's ?date= / ?openMatch=) -
       forces a fresh component instance. Otherwise Vue reuses the mounted page, created() never
       reruns, and it silently keeps showing the old data. -->
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.fullPath" />
  </router-view>
</template>

<style>
</style>
